export enum PropertyWidgetContextType {
  ISSUES, DEPLOY, PUBLISH, CREATE_VARIABLE, PATTERN_EDITOR
}
